// // src/utils/auth.js

// // ✅ Get JWT token from localStorage
// export const getToken = () => localStorage.getItem('authToken');

// // ✅ Get user object from localStorage
// export const getUser = () => {
//   const user = localStorage.getItem('user');
//   return user ? JSON.parse(user) : null;
// };

// // ✅ Check if user is logged in
// export const isLoggedIn = () => !!getToken();

// // ✅ Logout and redirect
// export const logout = () => {
//   localStorage.removeItem('authToken');
//   localStorage.removeItem('user');
//   window.location.href = '/login'; // or use useNavigate if inside React component
// };

// // ✅ Check if JWT token is expired
// export const isTokenExpired = () => {
//   const token = getToken();
//   if (!token) return true;

//   try {
//     const payload = JSON.parse(atob(token.split('.')[1]));
//     return payload.exp * 1000 < Date.now(); // `exp` is in seconds, so convert to ms
//   } catch (error) {
//     console.error('Error decoding token:', error);
//     return true;
//   }
// };

// // ✅ Optional: Get current user's role (assumes roles is an array)
// export const getUserRole = () => {
//   const user = getUser();
//   return user?.roles?.[0]?.name || null;
// };


// src/utils/auth.js

// Get JWT token from localStorage
export const getToken = () => localStorage.getItem('authToken');

// Get user object from localStorage
export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Check if user is logged in
export const isLoggedIn = () => !!getToken();

// Logout function
export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  window.location.href = '/login'; // Redirect to login
};

// Check if the token is expired (based on JWT "exp")
export const isTokenExpired = () => {
  const token = getToken();
  if (!token || !token.includes('.')) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now(); // `exp` is in seconds
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
};

// Get the first user role
export const getUserRole = () => {
  const user = getUser();
  return user?.roles?.[0]?.name || null;
};

// Get all roles
export const getUserRoles = () => {
  const user = getUser();
  return user?.roles?.map(role => role.name) || [];
};
